module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="history-list-item">\n    ';
 if( data ){ ;
__p += '\n    ';
 if( data.media_image != ''){ ;
__p += '\n    <div class="history-list-item__bg" style="background-image:none,url(/assets/img/history/' +
((__t = ( data.media_image )) == null ? '' : __t) +
');"></div>\n    ';
 }else{ ;
__p += '\n    <div class="history-list-item__bg" style="background-image:none,url(/assets/img/neko2.svg);"></div>\n    ';
 } ;
__p += '\n    <div class="history-list-item__content">\n        ';
 if( data.media_image != ''){ ;
__p += '\n        <div class="__content-pict" style="background-image:url(/assets/img/history/' +
((__t = ( data.media_image )) == null ? '' : __t) +
');"></div>\n        ';
 }else{ ;
__p += '\n        <div class="__content-pict" style="background-image:url(/assets/img/neko.svg);"></div>\n        ';
 } ;
__p += '\n\n        ';
 if( data.media_namelink != '' ){ ;
__p += '\n        <a class="__content-head" href="' +
((__t = ( data.media_namelink )) == null ? '' : __t) +
'" target="_blank">\n            ';
 if( data.media_year){ ;
__p += '<span class="__content-year">' +
((__t = ( data.media_year )) == null ? '' : __t) +
'.' +
((__t = ( data.media_month )) == null ? '' : __t) +
'</span>';
 }; ;
__p += '\n            <div class="u-column2">\n                <span class="__content-media u-column-item"><i class="fa fa-external-link" aria-hidden="true"></i> ' +
((__t = ( data.media_name )) == null ? '' : __t) +
'</span>\n                ';
 if( data.media_publisher){ ;
__p += '<span class="__content-publisher u-column-item">' +
((__t = ( data.media_publisher )) == null ? '' : __t) +
'</span>';
 }; ;
__p += '\n            </div>\n        </a>\n        ';
 }else{ ;
__p += '\n        <div class="__content-head">\n            ';
 if( data.media_year){ ;
__p += '<span class="__content-year">' +
((__t = ( data.media_year )) == null ? '' : __t) +
'.' +
((__t = ( data.media_month )) == null ? '' : __t) +
'</span>';
 }; ;
__p += '\n            <div class="u-column2">\n                <span class="__content-media u-column-item">' +
((__t = ( data.media_name )) == null ? '' : __t) +
'</span>\n                ';
 if( data.media_publisher){ ;
__p += '<span class="__content-publisher u-column-item">' +
((__t = ( data.media_publisher )) == null ? '' : __t) +
'</span>';
 }; ;
__p += '\n            </div>\n        </div>\n        ';
 }; ;
__p += '\n\n        <ul class="__content__note-list">\n            ';
 _.each(data.notes, function(item){ ;
__p += '\n            <li class="__note-list-item u-column2">\n                ';
 if(item.note !== data.media_name){ ;
__p += '<div class="__note-list-item__title u-column-item">' +
((__t = ( item.note )) == null ? '' : __t) +
'</div>';
 }; ;
__p += '\n                <div class="__note-list-item__charge u-column-item">' +
((__t = ( item.charge )) == null ? '' : __t) +
'</div>\n            </li>\n            ';
 }); ;
__p += '\n            ';
 if(data.media_charge){ ;
__p += '\n            <li class="__note-list-item u-column2">\n                <div class="__note-list-item__charge u-column-item">' +
((__t = ( data.media_charge )) == null ? '' : __t) +
'</div>\n            </li>\n            ';
 }; ;
__p += '\n        </ul>\n    </div>\n    ';
 } ;
__p += '\n</div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./htdocs/assets/js/_src/more-history/history-item.ejs
// module id = 40
// module chunks = 0